import script from "./CheckModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__